export default __webpack_public_path__ + "static/media/cardSportBG.b53db46f.png";